import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { START_PAGE } from "@/constants/pagination";
import { useContactFilterCache } from "@/features/contact/provider/ContactListFilterCacheProvider";
import { background, divider, text } from "@/theme/colors";
import { elevation } from "@/theme/variables";
import { isNumber, toNumber } from "@/utils/number";
import { Box, Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";

type Props = {
  totalPage?: number;
  count?: number;
};

export const ContactListPagination: FC<Props> = ({ totalPage }) => {
  const { contactFilterCache, setContactFilterCache } = useContactFilterCache();

  const page = parseInt(contactFilterCache?.page?.toString() || START_PAGE.toString());

  const [displayTotalPage, setDisplayTotalPage] = useState<number>(1);

  useEffect(() => {
    if (isNumber(totalPage)) {
      setDisplayTotalPage(totalPage > 0 ? totalPage : 1);
    }
  }, [totalPage]);

  const handleClickPagination = (page: number) => {
    setContactFilterCache({ ...contactFilterCache, page });
  };

  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={page}
        count={displayTotalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => {
          return (
            <PaginationItem
              slots={{ first: IconChevronsLeft, last: IconChevronsRight }}
              {...item}
              component={Box}
              onClick={() => handleClickPagination(toNumber(item.page))}
            />
          );
        }}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)`
  .MuiPaginationItem-root {
    border-radius: 6px;
    margin: 0 4px;
    box-shadow: ${elevation.sm};
    border-color: ${divider.middle};
    color: ${text.secondary};
  }

  .Mui-disabled {
    color: ${text.disable};
    background-color: ${background.disable};
    opacity: 1 !important;
  }

  .Mui-selected {
    color: ${text.white};
    background-color: ${background.main} !important;
  }

  .Mui-selected:hover {
    cursor: default;
    color: ${text.white};
    background-color: ${background.main} !important;
  }
`;
